import { useState } from 'react';

const faqs = [
  {
    q: 'Is VigorBuy Spreadsheet free to use?',
    a: 'Yes, the VigorBuy Spreadsheet is completely free to browse. You can explore all product categories, compare sellers, and read our buying guides at no cost. Simply visit the main site through any of our navigation links to start discovering products.',
  },
  {
    q: 'How often is the VigorBuy Spreadsheet updated?',
    a: 'The VigorBuy Spreadsheet is updated daily to ensure you always have access to the latest product listings, current prices, and active seller information. Our team continuously monitors product availability and market trends to keep everything fresh.',
  },
  {
    q: 'Is VigorBuy safe to use for international shopping?',
    a: 'Absolutely. We prioritize buyer safety with comprehensive guides on quality control, shipping protection, and seller verification. Every product listing in the VigorBuy Spreadsheet is vetted through our quality checklist before being featured.',
  },
  {
    q: 'How do I find specific products in the spreadsheet?',
    a: 'You can use our category navigation to browse by product type, or visit the main VigorBuy Sheet site for advanced search and filtering. Our 14 curated categories cover everything from shoes and clothing to accessories and perfumes.',
  },
  {
    q: 'Can beginners use the VigorBuy Spreadsheet?',
    a: 'Yes, the VigorBuy Spreadsheet is designed for everyone. Whether you are a first-time international shopper or an experienced buyer, our organized layout and detailed buying guides make product discovery straightforward and intuitive.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-24">
      <div className="px-6 md:px-10">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-700 border border-secondary-200 rounded-full whitespace-nowrap">
              FAQ
            </span>
            <h2 className="mt-4 text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              Frequently Asked Questions
            </h2>
            <p className="mt-3 text-base text-foreground-600 leading-relaxed">
              Everything you need to know about the VigorBuy Spreadsheet.
            </p>
          </div>

          {/* FAQ Accordion */}
          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                >
                  <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                    {faq.q}
                  </span>
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i
                      className={`ri-${openIndex === i ? 'subtract' : 'add'}-line text-lg text-foreground-500 transition-transform duration-200`}
                    ></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-6 pb-5 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}